import {GitBranchIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import {VALUES} from '../../../constants'
import type {BranchPickerRef$data} from '@github-ui/item-picker/branch'

type LinkedBranchesProps = {
  linkedBranches: BranchPickerRef$data[]
}

export function LinkedBranches({linkedBranches}: LinkedBranchesProps) {
  return (
    <>
      {linkedBranches.map(branch => {
        return (
          <ActionList.LinkItem
            href={VALUES.branchUrl(branch.name, branch.repository.nameWithOwner)}
            target="_blank"
            key={branch.id}
          >
            <ActionList.LeadingVisual
              sx={{
                paddingTop: 1,
              }}
            >
              <GitBranchIcon />
            </ActionList.LeadingVisual>
            {branch.name}
            <ActionList.Description variant="block">{branch.repository.nameWithOwner}</ActionList.Description>
          </ActionList.LinkItem>
        )
      })}
    </>
  )
}

try{ LinkedBranches.displayName ||= 'LinkedBranches' } catch {}